import { AxiosResponse } from 'axios';
import { BaseService } from './route.service';
import { ELeadOutcome } from '@layouts/pages/CRM/kanban-board/services/responses/lead.response';

export interface SearchLeadResult {
    id: string;
    name: string;
    phone?: string | null;
    columnName?: string | null;
    statusName?: string | null;
    statusColor?: string | null;
    outcome: ELeadOutcome;
}

export interface SearchPersonResult {
    id: string;
    name: string;
    phone?: string | null;
    companyName?: string | null;
}

export interface SearchConversationResult {
    id: number;
    contactName?: string | null;
    contactPhone?: string | null;
    channel: string;
    lastMessage?: string | null;
}

export interface GlobalSearchResponse {
    leads: SearchLeadResult[];
    people: SearchPersonResult[];
    conversations: SearchConversationResult[];
}

export class SearchService extends BaseService {
    protected get resourceName(): string {
        return 'crm/search';
    }

    public async search(term: string): Promise<AxiosResponse<{ data: GlobalSearchResponse }>> {
        return await this.get('', { q: term });
    }
}
